





















































import { Event, TemplateStep, SubEventSample, DateRange } from 'inscreva-sse-models';
import moment from 'moment';
import { Component, Vue, Prop } from 'vue-property-decorator';

import Modal from '@/components/base/Modal.vue';
import Talks from '@/components/templates/Talks.vue';
import { Template } from '@/models/template';
import { UiManagerService } from '@/services/UiManager';

@Component({
  components: {
    Talks,
    Modal,
  },
})
export default class EventInfoSiteTemplateComponent extends Vue {
  @Prop({ required: true })
  private event!: Event;

  private selectedTemplate: Template = null;

  private event_sample: Event = null;

  private templates: Array<Template> = [
    {
      name: 'Talks',
      options: {
        title: 'Curso/Palestra',
        subTitle: 'Palestrante',
      },
      description: `Um template específico para palestras. Contém informações vitais sobre as palestras e seus palestrantes.`,
    },
  ];

  created() {
    this.event_sample = Object.assign(new Event(), this.event) as Event;
    if (this.templates.length === 1) {
      this.openTemplateConfig(this.templates[0]);
    }
  }

  get is_new_event() {
    return !this.event._id;
  }

  isEditingSubEvent(): boolean {
    return this.event_sample.subEvents.some((subEvent) => (subEvent as any).hidden === false);
  }

  get sub_events_date(): Array<DateRange> {
    return this.event.subEvents.map(({ info }) => info.date);
  }

  get last_subevent_date(): DateRange {
    return new Array<DateRange>()
      .concat(this.sub_events_date)
      .sort(({ end: endA }, { end: endB }) => new Date(endA).getTime() - new Date(endB).getTime())
      .pop();
  }

  get first_available_date(): DateRange & { hidden: boolean } {
    const lastSubEventStartPlus1Day =
      this.last_subevent_date && moment(this.last_subevent_date.start).add(1, 'days').toISOString();
    const lastSubEventEndPlus1Day =
      this.last_subevent_date && moment(this.last_subevent_date.end).add(1, 'days').toISOString();
    return {
      ...((this.last_subevent_date && {
        start:
          new Date(lastSubEventStartPlus1Day) <= new Date(this.event_sample.info.date.end)
            ? lastSubEventStartPlus1Day
            : moment(this.last_subevent_date.end).toISOString(),
        end:
          new Date(lastSubEventEndPlus1Day) <= new Date(this.event_sample.info.date.end)
            ? lastSubEventEndPlus1Day
            : moment(this.last_subevent_date.end).toISOString(),
      }) || {
        start: this.event_sample.info.dates[0].start,
        end: this.event_sample.info.dates[0].start,
      }),
      hidden: false,
    };
  }

  isSelected(template: Template) {
    return this.selectedTemplate?.name === template.name;
  }

  private openTemplateConfig(template: Template) {
    this.selectedTemplate = template;
    const index = this.event.steps.findIndex((step) => step.type === 'template');
    if (index === -1) {
      this.event.steps.push({
        type: 'template',
        template: `${template.name}Template`,
        info: { identifier: template.name },
      } as TemplateStep);
    }
  }

  onUpdateEvent(event: Event) {
    this.event_sample = event;
    this.$emit('on-update', event);
  }

  addSubEvent() {
    this.event_sample.subEvents = this.event_sample.subEvents.map((subEvent) =>
      Object.assign(subEvent, { hidden: undefined }),
    );
    const subEventSample = SubEventSample.generateSample({ parent: { _id: this.event._id } });
    (subEventSample as any).hidden = false;
    subEventSample.info.date = this.first_available_date;
    this.event_sample = Object.assign(new Event(), this.event_sample, {
      subEvents: this.event_sample.subEvents.concat([subEventSample]),
    }) as Event;
    setTimeout(() => UiManagerService.scrollTo(`#subEvent-${this.event_sample.subEvents.length - 1}`), 250);
  }
}
